import { useEffect, useState, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { isEmpty } from 'lodash'

import { Box, Typography } from '@mui/material'

function MarkerInfoBanner(props) {
	const { markerInfo, setMarkerInfo } = props
	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				position: 'absolute',
				top: 10,
				left: '50%',
				transform: 'translateX(-50%)',
				zIndex: 1000,
				backgroundColor: 'white',
				p: 1,
				boxShadow: 3,
				width: '40%',
				maxWidth: '20em',
			}}
		>
			{markerInfo?.content}
		</Box>
	)
}

export function useMarkerInfoBanner() {
	const [markerInfo, setMarkerInfo] = useState(null)

	function handleMouseOverChangeMarkerInfo(id, callback) {
		setMarkerInfo((pre) => {
			if (pre?.id === id) {
				return pre
			}

			return callback?.() || pre
		})
	}

	function handleMouseOutChangeMarkerInfo(id) {
		setMarkerInfo((pre) => {
			if (pre?.id === id) {
				return null
			}

			return pre
		})
	}

	const buildMarkerInfoBanner = useCallback(
		() => (isEmpty(markerInfo) ? null : <MarkerInfoBanner markerInfo={markerInfo} />),
		[markerInfo]
	)

	return {
		markerInfo,
		setMarkerInfo,
		handleMouseOverChangeMarkerInfo,
		handleMouseOutChangeMarkerInfo,
		buildMarkerInfoBanner,
	}
}
